export default __webpack_public_path__ + "fonts/inter-latin-800-normal.af14b68e3ebadbf8a07f.woff";